var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUdsmediaassets87(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.92,80c-.97-.44-1.33-1.17-1.3-2.24,.25-7.14,3.14-13.01,8.63-17.54,4.15-3.42,8.98-5.08,14.37-5.07,2.3,0,4.61-.05,6.91,0,9.14,.23,15.83,4.52,20.22,12.44,1.73,3.12,2.49,6.53,2.61,10.1,.04,1.08-.29,1.86-1.3,2.3H24.92Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.01,20c8.74,0,15.81,7.08,15.81,15.83,0,8.74-7.08,15.81-15.83,15.81-8.76,0-15.82-7.1-15.81-15.89,.01-8.69,7.11-15.75,15.83-15.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdsmediaassets87);
export default __webpack_public_path__ + "static/media/UDS MEDIA ASSETS-87.8ca25b3efbd6a5f40b9f1dac2165d973.svg";
export { ForwardRef as ReactComponent };